import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "@pcln/horizon";
import { searchFormCard } from "./SearchFormCard.variants.js";
const SearchFormCard_SearchFormCard = /*#__PURE__*/ forwardRef(function({ 'aria-label': ariaLabel = 'Search form', children, className, contentClassName, role = 'region', variant = 'panel', width = 'full', ...props }, ref) {
    const styles = searchFormCard({
        variant,
        width
    });
    return /*#__PURE__*/ jsx("div", {
        "aria-label": ariaLabel,
        className: cn(styles.root(), className),
        ref: ref,
        role: role,
        ...props,
        children: /*#__PURE__*/ jsx("div", {
            className: cn(styles.content(), contentClassName),
            children: children
        })
    });
});
export { SearchFormCard_SearchFormCard as SearchFormCard };
